import React from "react";
import TE911Location from "../../../models/TE911Location";
import styles from "./LocationList.module.css";
import LocationCard from "../LocationCard";
import { User } from "../../../models/User";
import LocationsToolbar from "./LocationsToolbar";

interface LocationListProps {
  locations: TE911Location[] | undefined;
  /** Indicates that an export is in progress, displays a spinner next to the export button. */
  isExporting: boolean;
  /** Indicates that an import is in progress, displays a spinner next to the import button. */
  isImporting: boolean;
  user: User | null;
  onAddLocationClick(): void;
  onExportClick(): void;
  onImportClick(): void;
  onSearchChange(search: string): void;
  onLocationSelected(location: TE911Location): void;
}

function LocationList(props: LocationListProps) {
  const renderLocations = () => {
    if (props.locations === undefined || props.locations.length === 0) {
      return (
        <div className="col-start-2 col-span-10 lg:col-start-3 lg:col-span-8">
          <div className="bg-gray-950 text-purple-1 border-2 border-gray-950 rounded-lg p-3 pt-5 pb-5 text-center">
            <span className="text-display-sm">No locations were found</span>
          </div>
        </div>
      );
    } else {
      return (
        <>
          {props.locations.map((location, key) => (
            <div
              key={key}
              className="col-start-2 col-span-10 lg:col-start-3 lg:col-span-8"
            >
              <LocationCard
                location={location}
                onClick={props.onLocationSelected}
              />
            </div>
          ))}
        </>
      );
    }
  };

  return (
    <>
      <LocationsToolbar
        isExporting={props.isExporting}
        isImporting={props.isImporting}
        user={props.user}
        onAddLocationClick={props.onAddLocationClick}
        onExportClick={props.onExportClick}
        onImportClick={props.onImportClick}
        onSearchChange={props.onSearchChange}
      />
      <div className={styles.contentWrapper}>{renderLocations()}</div>
    </>
  );
}

export default LocationList;
